import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 bg-background border-t border-white/5 text-center" data-id="element-67">
      <div className="max-w-4xl mx-auto" data-id="element-68">
        <p className="text-textMuted text-sm mb-4" data-id="element-69">
          © {new Date().getFullYear()} Sculpt-It. Todos los derechos
          reservados.
        </p>
        <div className="flex items-center justify-center gap-4 text-xs text-textMuted/60" data-id="element-70">
          <a href="#" className="hover:text-accent transition-colors" data-id="element-71">
            Términos y Condiciones
          </a>
          <span data-id="element-72">|</span>
          <a href="#" className="hover:text-accent transition-colors" data-id="element-73">
            Política de Privacidad
          </a>
          <span data-id="element-74">|</span>
          <a href="#" className="hover:text-accent transition-colors" data-id="element-75">
            Contacto
          </a>
        </div>
        <p className="text-xs text-textMuted/40 mt-6 max-w-2xl mx-auto" data-id="element-76">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}